function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState, useContext } from 'react';
import { Dropdown, Menu } from 'antd';
import classnames from 'classnames';
import { TimeOutlined, ArrowUpOutlined, ArrowDownOutlined } from 'iglooicon';
import Input from "../input/index";
import Typography from "../typography";
import "./style";
import "../input/style/index";
import { staticFormatMessage, LocaleContext } from "../locale";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IglooTimeSelect = function IglooTimeSelect(props) {
  var formChangeProp = props.onChange,
    setFieldValue = props.setFieldValue,
    disabled = props.disabled,
    value = props.value;

  // 为了让yarn 指令找到这一条国际化信息
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var staticMessage = formatMessage({
    id: 'Please enter a valid time.'
  });
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    finalDisplayValue = _useState2[0],
    setDisplayValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dropDownVisible = _useState4[0],
    setDropDownVisible = _useState4[1];
  // 只用来控制disable样式的展示
  // const [meridiemDisable, setMeridiemDisable] = useState(false);

  // topDomRef 用来挂载DropDwon
  var topDomRef = useRef(null);
  var secondInputRef = useRef(null);
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    hourValue = _useState6[0],
    setHourVale = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    minuteValue = _useState8[0],
    setMinuteVale = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    meridiem = _useState10[0],
    setMeridiem = _useState10[1];
  useEffect(function () {
    if (!value) return;
    setDisplayValue(value);
    formChangeProp && formChangeProp(value);
  }, []);
  useEffect(function () {
    if (hourValue === '' && minuteValue === '') return;
    var finalStr = "".concat(hourValue, ":").concat(minuteValue, " ").concat(meridiem ? 'AM' : 'PM');
    // 对于这个组件来说每一次输入都是正确的 但是拼在一起 可能不正确（有些可能没输入）因此此处不使用setFieldError，在自定义rule中检验
    setFieldValue && setFieldValue(finalStr);
    setDisplayValue(finalStr);
    if (finalStr.length === 8) {
      formChangeProp && formChangeProp(finalStr);
    }
  }, [hourValue, minuteValue, meridiem]);
  var hourRange = {
    begin: 1,
    end: 12
  };
  var minuteRange = {
    begin: 0,
    end: 59
  };
  var judgeTime = function judgeTime(range, value) {
    var begin = range.begin,
      end = range.end;
    return value >= begin && value <= end;
  };
  var handleTimeInput = function handleTimeInput(range, value, setTime) {
    var end = range.end;
    var isHour = end < 13;
    var pureNumInput = value.replace(/[^0-9]/gi, '');

    // 防止出现类似输入00  再输入 001之后表现不正常的情况
    if (pureNumInput.length > 2) return;
    if (pureNumInput === '') {
      setTime(pureNumInput);
      return;
    }
    var toNum = Number(pureNumInput);
    if (isHour) {
      switch (pureNumInput) {
        case '0':
          setTime('0');
          return;
        case '00':
          setTime('00');
          secondInputRef.current.focus();
          return;
        case '1':
          setTime('1');
          return;
        case '01':
          setTime('01');
          secondInputRef.current.focus();
          return;
        default:
          if (toNum < 10) {
            setTime('0' + toNum);
            secondInputRef.current.focus();
            return;
          }
          if (judgeTime(range, toNum)) {
            setTime(toNum);
            secondInputRef.current.focus();
            return;
          }
      }
    } else {
      if (pureNumInput === '00') {
        setTime(pureNumInput);
        return;
      }
      if (pureNumInput.length === 2 && toNum < 10) {
        setTime(pureNumInput);
        return;
      }
      if (pureNumInput.length === 1 && toNum > 5) {
        setTime('0' + toNum);
        return;
      }
      judgeTime(range, toNum) && setTime(toNum);
    }
  };
  var handleTimeSwitchButton = function handleTimeSwitchButton(range, value, setTime, actionType) {
    var begin = range.begin,
      end = range.end;
    var toNum = Number(value);
    switch (actionType) {
      case 'up':
        var addTime = toNum + 1 > end ? begin : toNum + 1;
        addTime > 9 ? handleTimeInput(range, String(addTime), setTime) : handleTimeInput(range, '0' + addTime, setTime);
        break;
      case 'down':
        var lessTime = toNum - 1 < begin ? end : toNum - 1;
        lessTime > 9 ? handleTimeInput(range, String(lessTime), setTime) : handleTimeInput(range, '0' + lessTime, setTime);
    }
  };
  var meridiemSwitch = function meridiemSwitch(hourValue) {
    setMeridiem(!meridiem);
  };
  var menu = /*#__PURE__*/_jsx(Menu, {
    children: /*#__PURE__*/_jsx(Menu.Item, {
      children: /*#__PURE__*/_jsxs("div", {
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        className: "igloo-drop-down-content",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ArrowUpOutlined, {
            onClick: function onClick() {
              return handleTimeSwitchButton(hourRange, hourValue, setHourVale, 'down');
            }
          }), /*#__PURE__*/_jsx(Input, {
            onChange: function onChange(e) {
              return handleTimeInput(hourRange, e.target.value, setHourVale);
            },
            value: hourValue
          }), /*#__PURE__*/_jsx(ArrowDownOutlined, {
            onClick: function onClick() {
              return handleTimeSwitchButton(hourRange, hourValue, setHourVale, 'up');
            }
          })]
        }), /*#__PURE__*/_jsx("span", {
          children: ":"
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ArrowUpOutlined, {
            onClick: function onClick() {
              return handleTimeSwitchButton(minuteRange, minuteValue, setMinuteVale, 'down');
            }
          }), /*#__PURE__*/_jsx(Input, {
            ref: secondInputRef,
            onChange: function onChange(e) {
              return handleTimeInput(minuteRange, e.target.value, setMinuteVale);
            },
            value: minuteValue
          }), /*#__PURE__*/_jsx(ArrowDownOutlined, {
            onClick: function onClick() {
              return handleTimeSwitchButton(minuteRange, minuteValue, setMinuteVale, 'up');
            }
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(ArrowUpOutlined, {
            className: classnames({
              // 'igloo-hour-select-meridiem-disable': meridiemDisable,
            }),
            onClick: function onClick() {
              return meridiemSwitch(hourValue);
            }
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(Typography, {
              level: "body1",
              children: meridiem ? 'AM' : 'PM'
            })
          }), /*#__PURE__*/_jsx(ArrowDownOutlined, {
            className: classnames({
              // 'igloo-hour-select-meridiem-disable': meridiemDisable,
            }),
            onClick: function onClick() {
              return meridiemSwitch(hourValue);
            }
          })]
        })]
      })
    }, '0')
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "igloo-hour-select",
    ref: topDomRef,
    children: [/*#__PURE__*/_jsx(Dropdown, {
      onOpenChange: function onOpenChange(open) {
        return setDropDownVisible(open);
      },
      overlay: menu,
      trigger: ['click'],
      overlayClassName: 'igloo-drop-down-container',
      getPopupContainer: function getPopupContainer() {
        return topDomRef.current;
      },
      disabled: disabled,
      children: /*#__PURE__*/_jsx(Input, {
        value: finalDisplayValue,
        className: classnames('igloo-input', {
          'igloo-hour-select-input-active': dropDownVisible
        })
      })
    }), /*#__PURE__*/_jsx(TimeOutlined, {
      className: classnames({
        'igloo-hour-select-active': dropDownVisible
      })
    })]
  });
};
function checkCard(value) {
  if (!value) {
    return Promise.resolve();
  }
  if (value.length !== 8) {
    return Promise.reject(staticFormatMessage({
      id: 'Please enter a valid time.'
    }));
  } else {
    var hour = value.split(':')[0];
    var conMinStr = value.split(':')[1];
    if (hour === undefined || hour > '12' || hour < '01' || hour.length !== 2) {
      return Promise.reject(staticFormatMessage({
        id: 'Please enter a valid time.'
      }));
    }
    var min = conMinStr.split(' ')[0];
    if (min === undefined || min > '59' || min.length !== 2) {
      return Promise.reject(staticFormatMessage({
        id: 'Please enter a valid time.'
      }));
    }
    var timeType = conMinStr.split(' ')[1];
    if (timeType !== 'PM' && timeType !== 'AM') {
      return Promise.reject(staticFormatMessage({
        id: 'Please enter a valid time.'
      }));
    }
  }
  return Promise.resolve();
}
IglooTimeSelect.formItemPropsHandler = function (config) {
  return {
    rules: [{
      validator: function validator(_, value) {
        return checkCard(value);
      }
    }]
  };
};
export default IglooTimeSelect;